import type { Board } from "@/model/board";
import type { Card } from "@/model/card";
import { isDependency } from "@/model/stickyType";

import { useTeamStore } from "../team";

export function mirrorableToNonFlexBoard(cards: Card[], board: Board) {
  if (!["program", "solution", "risk", "team"].includes(board.type)) {
    return false;
  }
  if (board.artId && board.artId !== useTeamStore().current.artId) {
    return false;
  }
  return (
    typesMirrorableToBoard(cards, board) && anyNonOrigin(cards, board) && matchingTeam(cards, board)
  );
}

function typesMirrorableToBoard(cards: Card[], board: Board) {
  return cards.every((card) =>
    card.type.usable.some(
      (boardType) =>
        boardType === board.type &&
        (boardType !== "program" || card.teamId) &&
        (boardType !== "solution" || mirrorableToSolutionBoard(card)),
    ),
  );
}

function mirrorableToSolutionBoard(card: Card): boolean {
  // External-team dependencies should not be mirrored to the solution planning board:
  // there is no swimlane for external teams, and merging them into the ART swimlane
  // does not make sense and just crowds the board.
  if (isDependency(card) && card.dependTeam?.external) {
    return false;
  }
  // Cards with an artId can always be mirrored; dependencies are also mirrorable
  // if they cross ART boundaries (precondTeam and dependTeam belong to different ARTs).
  return !!card.artId || (isDependency(card) && card.precondTeam?.artId !== card.dependTeam?.artId);
}

function anyNonOrigin(cards: Card[], board: Board) {
  return cards.some((card) => board.type !== card.type.origin);
}

function matchingTeam(cards: Card[], board: Board) {
  return (
    board.type !== "team" || cards.every((card) => !card.teamId || board.team.id === card.teamId)
  );
}
